import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

export const StyledSkeleton = styled.div<{
  width?: string;
  height?: string;
  $rounded?: boolean;
}>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "1.2rem"};
  border-radius: ${({ theme, $rounded }) => ($rounded ? "50%" : theme.borderRadius.sm)};
  background: ${({ theme }) => theme.colors.background};
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.background} 0px,
    ${({ theme }) => theme.colors.border} 50%,
    ${({ theme }) => theme.colors.background} 100%
  );
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite linear;
  display: inline-block;
`;
